<template>
    <div class="container-fluid">
        <div class="row">
            <FormDocumentPreparation colClass="col-12" headerTitle="true" titles="true" v-model:products="formDocumentPreparation"/>
            <DomeReceipt v-model:products="domeReceipt"/>
        </div>
        <button class="btn btn-success pull-right" type="button" @click="submitForm">บันทึก</button>
    </div>
</template>
<script setup>
import { ref, defineAsyncComponent } from 'vue'
import { directus } from "@/services/directus"
import { readItems , createItem , updateItems , updateItem} from "@directus/sdk"
import { useRouter } from 'vue-router';
import Swal from 'sweetalert2'
const FormDocumentPreparation = defineAsyncComponent(() => import("@/components/theme/receipt-product/FormDocumentPreparation.vue"))
const DomeReceipt = defineAsyncComponent(() => import("@/components/theme/receipt-product/DomeReceipt.vue"))

const formDocumentPreparation = ref([]);
const domeReceipt = ref([]);
const router = useRouter();

async function generatePreparationNumber() {
  const prefix = "OFD-";
  const date = new Date();
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const formattedDate = `${year}${month}${day}`;
  let docNumber = "";
  try {
    const packing_sheet = await directus.request(
      readItems("packing_sheet", {
        fields: ['*'],
        filter: {
          document_preparation_number: {
            _contains: `${prefix}${formattedDate}`,
          },
        },
        limit: -1
      })
    );
    const sequence = String(packing_sheet.length + 1).padStart(2, '0');
    docNumber = `${prefix}${formattedDate}${sequence}`;
  } catch (error) {
    console.error("Error generating preparation number:", error);
  }
  return docNumber;
}

const submitForm = () => {
    addPorducts()
};

function transformProductList(products, stock_id) {
    return products.flatMap(product => 
        product.serialNumbers.map(serial => {
            const stockItem = stock_id.find(item => item.serial_number === serial);
            return {
                productId: stockItem ? stockItem.id : null,
                productName: product.productName,
                productCode: product.productCode,
                productModel: product.productModel,
                productBrand: product.productBrand,
                counter: 1,
                serialNumbers: serial,
                selectedModel: product.selectedModel,
                status: 'รอเช็คก่อนส่ง',
                remarks: '',
            };
        })
    );
}

async function addPorducts() {
    const docNumber = await generatePreparationNumber()
    try {
        const stock_id = []
        for (let index = 0; index < domeReceipt.value.length; index++) {
            const stockIds = domeReceipt.value[index].serialNumbers;
            const readStock = await directus.request(
                readItems("stock", {
                fields: ['id','history','serial_number'],
                filter: {
                    serial_number: {
                        _in: stockIds,
                    },
                },
                limit: -1
                })
            );
            stock_id.push(...readStock);
        }

        const productlist = transformProductList(domeReceipt.value , stock_id);

        if (stock_id.length == 0) {
            errorAlert()
            return
        }

        const timestamp = new Date().toISOString().split('.')[0];
        const user = localStorage.getItem('user_full_name');

        const waitTransaction = {
            "transaction_type": "update",
            "timestamp": timestamp,
            "remarks": "เปลี่ยสถานะเป็น รอเช็คก่อนส่ง",
            "user": user
        };

        const newTransaction = {
            "transaction_type": "update",
            "timestamp": timestamp,
            "remarks": `เพิ่มเข้าใบจัดของ เลขที่ ${docNumber}`,
            "user": user
        };

        const create = await directus.request(
            createItem('packing_sheet', {
                document_preparation_number: docNumber,
                customer_name: formDocumentPreparation.value.customerName,
                company_name: formDocumentPreparation.value.companyName,
                branch_name: formDocumentPreparation.value.branchName,
                branch_code: formDocumentPreparation.value.branchCode,
                product_preparation_date: formDocumentPreparation.value.preparedDate,
                plan_delivery_date: formDocumentPreparation.value.deliveryDate,
                quotation_number_office_design: formDocumentPreparation.value.quotationNumber,
                customer_order_number: formDocumentPreparation.value.customerOrderNumber,
                prepared_by: formDocumentPreparation.value.user,
                bill_number: formDocumentPreparation.value.billNumber,
                status: 'รอเช็คก่อนส่ง',
                stock_snapshot: productlist,
            })
        )

        for (let index = 0; index < stock_id.length; index++) {
            if (!Array.isArray(stock_id[index].history)) {
                stock_id[index].history = [];
            }
            stock_id[index].history.push(waitTransaction);
            stock_id[index].history.push(newTransaction);
            
            await directus.request(
                updateItem('stock', stock_id[index].id, {
                    history: stock_id[index].history,
                    stock_id: create.id,
                    status: 'รอเช็คก่อนส่ง',
                })
            );
        }

        successAlert(create.id)
    } catch (error) {
        dangerAlert()
        console.error('Error creating article:', error);
    }
}

function successAlert(itemId) {
    Swal.fire({
        icon: "success",
        title: "อัพเดทสำเร็จ!",
        confirmButtonColor: 'var(--theme-default)',
    }).then(() => {
        router.push({ name: 'documentPreparationDetail' , params: { id: itemId , type: 'preparation' } });
    });
}

function errorAlert() {
    Swal.fire({
        icon: "error",
        title: "กรุณากรอกข้อมูลให้ครบ!",
        confirmButtonColor: 'var(--theme-default)',
    });
}

function dangerAlert() {
    Swal.fire({
        icon: "error",
        title: "บันทึกข้อมูลไม่สำเร็จ!",
        confirmButtonColor: 'var(--theme-default)',
    });
}
</script>